import React from "react";
import { useQuery } from "@apollo/client";
import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_STORAGE } from "../../../queries/archiveQrys/InventoryReportQueries";
import { materialType } from "../../../utilities/constants/StorageConstants";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const StorageTable = ({ systemId }) => {
  const columns = [
    {
      Header: "ID",
      accessor: "storageId",
      disableFilters: true
    },
    {
      Header: "Name",
      accessor: "storageName",
      disableFilters: true
    },
    {
      Header: "Name",
      accessor: "storageType",
      disableFilters: true
    },
    {
      Header: "Effective Volume",
      accessor: "effectiveVolume",
      disableFilters: true
    },
    {
      Header: "Material",
      accessor: (d) => {
        return d.material ? materialType[d.material] : "";
      },
      disableFilters: true
    },
    {
      Header: "Status",
      accessor: (d) => {
        return d.status === "A" ? "Active" : "Inactive";
      },
      disableFilters: true
    },
    {
      Header: "Status Reason",
      accessor: "statusReason",
      disableFilters: true
    }
  ];

  const { loading, error, data } = useQuery(GET_STORAGE, { variables: { systemId } });
  if (loading) return <SkeletonLoader width='100%' />;
  if (error) return <ErrorHandler error={error} />;
  return <DtsReactTable data={data.getStorageBySystemId} columns={columns} headerColor='ddw' />;
};

export default StorageTable;
